import { render, staticRenderFns } from "./EstimageMessageNew.vue?vue&type=template&id=59414bb6"
import script from "./EstimageMessageNew.vue?vue&type=script&lang=js"
export * from "./EstimageMessageNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59414bb6')) {
      api.createRecord('59414bb6', component.options)
    } else {
      api.reload('59414bb6', component.options)
    }
    module.hot.accept("./EstimageMessageNew.vue?vue&type=template&id=59414bb6", function () {
      api.rerender('59414bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/estimagemessage/EstimageMessageNew.vue"
export default component.exports